export const invitedStatus = {
	PENDING: 'Pending',
	INVITED: 'Invited',
	INVITING: 'Inviting'
};
